import React from "react";
import Button from "components/button/Button";
import CommonModal from "components/modals/Modal";
import TextField from "components/fields/TextField";
import InputField from "components/fields/InputField";
import SwitchField from "components/fields/SwitchField";
import useCourierDetail from "../../hooks/useCourierDetail";
import NumFormatField from "components/fields/NumFormatField";
import { ModalBody, ModalCloseButton, ModalHeader } from "@chakra-ui/modal";
import { Controller, FieldValues, useForm } from "react-hook-form";
import {
  ICourierService,
  ICourierServiceCreate,
} from "../../types/courier.interface";

interface ICourierServiceForm {
  courierId: number;
  service?: ICourierService;
  isOpen: boolean;
  onClose: () => void;
}

const CourierServiceForm: React.FC<ICourierServiceForm> = (props) => {
  const { courierId, service, isOpen, onClose } = props;
  const { fetchServices, onSubmit, onUpdate } = useCourierDetail(
    courierId.toString()
  );
  const [isLoading, setIsLoading] = React.useState(false);
  const {
    register,
    control,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();

  const onSubmitForm = async (data: FieldValues) => {
    let promise: Promise<any>;
    const payload: ICourierServiceCreate = data as ICourierServiceCreate;
    setIsLoading(true);

    if (service) promise = onUpdate(courierId, service.id, payload);
    else promise = onSubmit(courierId, payload);

    promise
      .then(() => {
        fetchServices(courierId);
        setIsLoading(false);
        onClose();
      })
      .catch(() => {
        setIsLoading(false);
      });
  };

  React.useEffect(() => {
    if (service) reset(service);
    else
      reset({
        is_active: false,
        name: "",
        etd: "",
        price_by_km: "",
        price_by_weight: "",
        description: "",
      });

    // eslint-disable-next-line
  }, [service]);

  return (
    <CommonModal
      size="3xl"
      children={
        <form onSubmit={handleSubmit(onSubmitForm)}>
          <ModalHeader>Tambah Layanan Baru</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <SwitchField
              label="Status Layanan Aktif"
              desc=""
              id="is_active"
              mb="mb-3"
              mt=""
              placeholder="Status Layanan Aktif"
              register={register}
              errors={errors}
              validationSchema={{}}
            />
            <div className="mb-3 grid grid-cols-12 gap-4">
              <InputField
                variant="outline"
                extra="col-span-12 lg:col-span-6"
                label="Nama Layanan"
                placeholder="Masukkan nama layanan"
                id="name"
                type="text"
                register={register}
                errors={errors}
                validationSchema={{
                  required: "Nama layanan harus diisi!",
                }}
              />
              <InputField
                variant="outline"
                extra="col-span-12 lg:col-span-6"
                label="Estimasi Sampai"
                placeholder="Masukkan Estimasi sampai misal 3-5 Hari"
                id="etd"
                type="text"
                register={register}
                errors={errors}
                validationSchema={{
                  required: "Estimasi Sampai harus diisi!",
                }}
              />
            </div>
            <div className="mb-3 grid grid-cols-12 gap-4">
              <Controller
                name="price_by_km"
                control={control}
                rules={{ required: "Harga/Km harus diisi!" }}
                render={({ field }) => (
                  <NumFormatField
                    field={field}
                    extra="col-span-12 lg:col-span-6"
                    decimalSeparator=","
                    thousandSeparator="."
                    errors={errors}
                    rules={{ required: "Harga/Km harus diisi!" }}
                    label="Harga/Km"
                    id="price_by_km"
                    placeholder="Masukkan harga per Km"
                    variant="outline"
                    prefix="Rp"
                    suffix="/Km"
                  />
                )}
              />
              <Controller
                name="price_by_weight"
                control={control}
                rules={{ required: "Harga/Kg harus diisi!" }}
                render={({ field }) => (
                  <NumFormatField
                    field={field}
                    extra="col-span-12 lg:col-span-6"
                    decimalSeparator=","
                    thousandSeparator="."
                    errors={errors}
                    rules={{ required: "Harga/Kg harus diisi!" }}
                    label="Harga/Kg"
                    id="price_by_weight"
                    placeholder="Masukkan harga per Kg"
                    variant="outline"
                    prefix="Rp"
                    suffix="/Kg"
                  />
                )}
              />
            </div>
            <TextField
              extra="mb-3 flex-1 mt-10 lg:mt-0"
              label="Deskripsi"
              placeholder="Deskripsi kurir"
              id="description"
              variant="outline"
              register={register}
              errors={errors}
              validationSchema={{}}
            />
            <Button
              children="Simpan"
              size="fit"
              variant="primary"
              extra="my-5 float-right"
              isLoading={isLoading}
            />
          </ModalBody>
        </form>
      }
      isOpen={isOpen}
      onClose={onClose}
    />
  );
};

export default CourierServiceForm;
